import UpcomingApptCard from 'src/components/UpcomingApptCard/UpcomingApptCard';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AdditionalServicesActionCreator, AppointmentActionCreator, FrameworkActionCreator, MenusActionCreator, QuickTimesActionCreator, SpecsActionCreator, WebOpsActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    apptVehicle: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    apptList: state.Appointment.ViewApptList,
    theme: state.Framework.theme,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
    recommendedServices: state.AdditionalServices.allServices.recom,
    individualServices: state.WebOps.WebOps ?? [],
    additionalServices: state.AdditionalServices,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    specData: state.Specs,
    profile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    apptVin: state.Appointment.ApptVeh.vin,
    menusReturnCode: state.Menus.allMenus.returnCode,
    waitOnRecall: state.Framework.waitOnRecall,
    locale: state.Framework.locale,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    MCReturned: state.AdditionalServices.maintContractData.MCReturned,
    MCError: state.AdditionalServices.maintContractData.MCError,
    waitOnMC: state.Framework.waitOnMC,
    apptVeh: state.Appointment.ApptVeh,
    TMNAMileage: state.AdditionalServices.maintContractData.TMNAMileage,
    vehicles: state.Vehicles.vehicles,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    updateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
    updateApptOps: AppointmentActionCreator.UpdateApptOps,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    getApptOps: WebOpsActionCreator.GetApptOps,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    determineDept: AppointmentActionCreator.DetermineDept,
    getMenus: MenusActionCreator.GetMenus,
    getQuickTimes: QuickTimesActionCreator.GetQuickTimes,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    toggleItem: WebOpsActionCreator.ToggleItems,
    toggleRecommended: AdditionalServicesActionCreator.ToggleRecommended,
    clearMenusState: MenusActionCreator.ClearMenusState,
    getMaintContracts: AdditionalServicesActionCreator.GetMaintContracts,
    setWaitOnMC: FrameworkActionCreator.SetWaitOnMC,
    updateVehicleMileage: AppointmentActionCreator.UpdateApptVehicleMileage,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UpcomingApptCard);